<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1000">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            Listagem de Participantes
          </div>
        </v-toolbar>
        <div class="container dialog mt-4">
          <h3>
            Listagem de Participantes
          </h3>
          <v-row class="justify-center">
            <v-data-table
                class="mt-5"
                :headers="headers"
                :items="lists.formacoes"
                :items-per-page="10"
                :footer-props="$footerProps"
                show-expand
                style="min-width: 800px;"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-4">
                  <v-simple-table dense>
                    <tbody>
                    <tr v-for="(participante, i) in item.participantes" :key="i">
                      <td>{{ participante.nome }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-row>
        </div>
        <v-row  class="d-flex justify-center total-participantes">
          <p>Total Geral de Participantes: {{totalParticipantes}}</p>
        </v-row>
        <v-row  class="d-flex justify-center mt-6 mb-4" style="gap:2rem;">
          <v-btn outlined color="primary" @click="$emit('onClose')">Voltar</v-btn>
          <v-btn color="primary" class="mr-3" @click="baixarRelatorioPdf">Exportar</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";

export default {
  props: new DialogProps(Dashboard),
  mixins: [DashboardFormacaoService],
  data: () => ({
    lists: {
      formacoes: [],
    },
    headers: [
    ],
  }),
  methods: {
    getFormacoes() {
      this.$buscarDashboardParticipantes({ params: {
        GreCodigo: this.content.id,
        OrigemId: this.content?.origemId,
        EscolaCodigo: this.content?.escolaCodigo,
        }}).then(
          ({ data }) => this.lists.formacoes= data.lista
      )
    },
    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardParticipantesPdf(this.$montarParamsFilters(
            {
              GreCodigo: this.content.id,
              OrigemId: this.content?.origemId,
              EscolaCodigo: this.content?.escolaCodigo,
            }));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.ListaDeParticipantes.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
    
    getHeaderGre() {
      return [
      { text: "Formação", align: "center", value: "formacao" },
      { text: "GRE", align: "center", value: "vweoNome" },
      { text: "Participantes", align: "center", value: "data-table-expand" },
      { text: "Total de Participantes", align: "center", value: "totalParticipantes"},
    ];
    },
    getHeaderEscola() {
      return [
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Data de Realizacao", align: "center", value: "dataRealizacao" },
        { text: "Local de Realização", align: "center", value: "localRealizacao" },
        { text: "Participantes", align: "center", value: "data-table-expand" },
        { text: "Total de Participantes", align: "center", value: "totalParticipantes"},
      ];
    }
  },
  computed: {
    totalParticipantes() {
      return this.lists.formacoes.reduce((total, formacao) => total + formacao.totalParticipantes, 0);
    }
  },
  mounted() {
    this.headers = this.content.origemId === 1 ? this.getHeaderGre() : this.getHeaderEscola();

    this.getFormacoes();
  },
}
</script>

<style scoped>

.total-participantes {
  font-size: 0.8rem;
  margin-top: -2.7rem;
  margin-left: -20rem;
}

</style>